/* Project Import will be here */
import { post, IRequest, authTokenKey } from "./index";
import {
  IRequestLoginOtpParams,
  ILoginParams,
  INewLoginParams,
  IJnJLoginParams,
  INewUserParams,
  IRequestMobChangeParams,
  IUpdateMobileNoParams,
  IVerifyOtpParams,
  ISignUpWithProfileParams,
  IForgotPassParams,
  IResetPasswordParams,
  INewLoginChangePasswordParams,
  INewLoginPasswordParams
} from "models/sessionModels";
/* Project Import will be here */

export const loginApi = (data: ILoginParams) => {
  const request: IRequest = {
    subUrl: `/Login/UserAuth`,
    data
  };
  return post(request, false);
};

/* Check given user id exist in the system */
export const checkLoginIdExistApi = (data: INewLoginParams) => {
  const request: IRequest = {
    subUrl: `/Login/CheckLoginIdExist`,
    data
  };
  return post(request, false);
};

/* For New loginApi  */
export const loginNewApi = (data: INewLoginPasswordParams) => {
  const request: IRequest = {
    subUrl: `/login/UserAuthentication`,
    data
  };
  return post(request, false);
};

export const loginJnJApi = (data: IJnJLoginParams) => {
  const request: IRequest = {
    subUrl: `/login/userauthwithMob`,
    data
  };
  return post(request, false);
};

export const newUserApi = (data: INewUserParams) => {
  const request: IRequest = {
    subUrl: `/Login/NewUser`,
    data
  };
  return post(request);
};

export const requestChangeMobOtpApi = (data: IRequestChangeMobNoParams) => {
  const request: IRequest = {
    subUrl: `/Login/RequestMobChangeOTP`,
    ...data
  };
  return post(request);
};

/* Login OTP request API */
export const requestMobChangeOTPApi = (data: IRequestMobChangeParams) => {
  const request: IRequest = {
    subUrl: `/Login/RequestMobChangeOTP`,
    ...data
  };
  return post(request);
};

export const changeMobileNoApi = (data: IChangeMobileNoParams) => {
  const request: IRequest = {
    subUrl: `/login/ChangeMobileNo`,
    ...data
  };
  return post(request);
}
export const updateMobileNoApi = (data: IUpdateMobileNoParams) => {
  const request: IRequest = {
    subUrl: `/login/ChangeMobileNo`,
    ...data
  };
  return post(request);
}

/* Login verification OTP verify API */
export const verifyOtpApi = (data: IVerifyOtpParams) => {
  const request: IRequest = {
    subUrl: `/Login/ValidateOTP`,
    ...data
  };
  return post(request);
};

/* Login verification request OTP API */
export const requestLoginVerificationOtp = (data: IRequestLoginOtpParams) => {
  const request: IRequest = {
    subUrl: `/Login/RequestOTP`,
    ...data
  };
  return post(request);
};

export const signUpWithProfileApi = (data: ISignUpWithProfileParams) => {
  const request: IRequest = {
    subUrl: `/Login/DirectRegistration`,
    data: data.data,
    headers: data.headers
  };
  return post(request);
};

export const forgotPasswordApi = (data: IForgotPassParams) => {
  const request: IRequest = {
    subUrl: `/Login/ForgetPassword`,
    data
  };
  return post(request);
};

export const resetPasswordApi = (data: IResetPasswordParams) => {
  const request: IRequest = {
    subUrl: `/Login/ResetPassword`,
    ...data
  };
  return post(request);
};

export const changePasswordApi = (data: INewLoginChangePasswordParams, token: any) => {
  const request: IRequest = {
    subUrl: `/Login/ChangePassword`,
    data: data,
    headers: { [authTokenKey]: token }
  };
  return post(request);
};